import {motion} from 'framer-motion';
import {useLanguage} from '../context/LanguageContext';

const About = () => {
  const {t, language} = useLanguage();

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{opacity: 0, y: 20}}
          animate={{opacity: 1, y: 0}}
          transition={{duration: 0.5}}
          className="text-center mb-12"
        >
          <div className="flex items-center justify-center space-x-4 mb-4">
            <img
              src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1750973984906-Mascotte_testa_1_to_1.png"
              alt="Cosmo Education Logo"
              className="h-16 w-16 rounded-full"
            />
            <h1 className="text-4xl font-bold text-gray-900">
              {language === 'en' ? 'COSMO Team' : 'Team COSMO'}
            </h1>
          </div>
        </motion.div>

        {/* Single Column Layout with Dr. Vetere's Profile */}
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{opacity: 0, y: 20}}
            animate={{opacity: 1, y: 0}}
            transition={{delay: 0.3, duration: 0.5}}
            className="bg-white p-8 rounded-lg shadow-lg"
          >
            <div className="text-center mb-8">
              {/* Real Photo of Dr. Vetere */}
              <img
                src="https://i.imgur.com/6h7mfDr.png"
                alt="Dr. Carlo Vetere"
                className="w-32 h-32 rounded-full object-cover shadow-xl border-4 border-white mx-auto mb-4"
              />
              <h2 className="text-2xl font-bold text-gray-900">Dr. Carlo Vetere</h2>
              <p className="text-gray-600 mb-4">
                {language === 'en' ? 'Author of COSMO' : 'Autore di COSMO'}
              </p>
            </div>

            {/* Dr. Vetere's complete description */}
            <div className="text-gray-700 leading-relaxed space-y-6">
              {language === 'en' ? (
                <>
                  <p className="text-lg">
                    Trainer and clinical staff member at the <strong>Istituto Veneto di Terapia Familiare (ITFV)</strong> and Board Member of <strong>AITF – the Association of Family Therapy Institutes</strong>, Dr. Vetere is the founder and author of <strong>COSMO (Collaborative Scoring Method)</strong>, the new coding system for Rosenzweig's Picture Frustration Study.
                  </p>
                  
                  <p className="text-lg">
                    COSMO introduces an interpersonal perspective that combines assessment capacity with clinical utility, proving especially effective in collaborative contexts.
                  </p>
                  
                  <p className="text-lg">
                    With over 15 years of experience in psychiatric rehabilitation and international adoptions, Dr. Vetere has gained extensive expertise in working with adults, adolescents, and families, including in challenging environments such as foster homes, residential communities, and correctional facilities.
                  </p>
                  
                  <p className="text-lg">
                    He is also certified in <strong>Therapeutic Assessment</strong> with adult patients, a training that has further shaped his collaborative approach and focus on building therapeutic alliance.
                  </p>
                  
                  <p className="text-lg">
                    From this rich clinical and teaching background, <strong>COSMO</strong> was born: a practical and innovative tool designed to support therapists at every stage of the process, foster trust from the very first session, and enable authentic, transformative therapeutic work.
                  </p>
                  
                  <p className="text-lg">
                    The <strong>COSMOPersonality platform</strong> emerges from this journey, with the aim of providing mental health professionals with an innovative, practical, and collaborative environment that enriches both clinical practice and training.
                  </p>
                </>
              ) : (
                <>
                  <p className="text-lg">
                    Didatta e membro dello staff clinico dell'<strong>Istituto Veneto di Terapia Familiare (ITFV)</strong> e Membro del Board di <strong>AITF – Associazione di Istituti di Terapia Familiare</strong>, il Dr. Vetere è l'autore di <strong>COSMO (Collaborative Scoring Method)</strong>, il nuovo sistema di codifica per il Picture Frustration Study di Rosenzweig.
                  </p>
                  
                  <p className="text-lg">
                    COSMO introduce una prospettiva interpersonale che unisce capacità valutativa e utilità clinica, con particolare efficacia nei contesti collaborativi.
                  </p>
                  
                  <p className="text-lg">
                    Con oltre 15 anni di esperienza nella riabilitazione psichiatrica e nel campo delle adozioni internazionali, il Dr. Vetere ha maturato una competenza trasversale nel lavoro con adulti, adolescenti e famiglie, anche in scenari complessi come comunità educative, case-famiglia e istituti penitenziari.
                  </p>
                  
                  <p className="text-lg">
                    È inoltre certificato in <strong>Therapeutic Assessment</strong> con pazienti adulti, formazione che ne ha rafforzato l'approccio collaborativo e l'attenzione alla costruzione dell'alleanza terapeutica.
                  </p>
                  
                  <p className="text-lg">
                    Dalla sua esperienza clinica e didattica nasce <strong>COSMO</strong>, uno strumento pensato per supportare i terapeuti in ogni fase della relazione, facilitare la fiducia sin dal primo incontro e promuovere un lavoro terapeutico autentico e trasformativo.
                  </p>
                  
                  <p className="text-lg">
                    La piattaforma <strong>COSMOPersonality</strong> nasce da questo percorso, con l'obiettivo di offrire a terapeuti e professionisti della salute mentale un ambiente innovativo, pratico e collaborativo, capace di arricchire tanto la pratica clinica quanto la formazione.
                  </p>
                </>
              )}
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default About;